import React from 'react'

function SvgTwitter(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="M22.55 5.46a8.89 8.89 0 01-2.17 2.24v.56a12.32 12.32 0 01-.51 3.48 12.72 12.72 0 01-1.55 3.33 13 13 0 01-2.47 2.82 11.2 11.2 0 01-3.45 1.95 12.62 12.62 0 01-4.33.73 12 12 0 01-6.64-1.94 8.33 8.33 0 001 .05 8.47 8.47 0 005.37-1.84A4.22 4.22 0 015.34 16a4.19 4.19 0 01-1.52-2.14 4.75 4.75 0 00.81.07 4.35 4.35 0 001.14-.15 4.2 4.2 0 01-2.48-1.49 4.17 4.17 0 01-1-2.75 4.33 4.33 0 002 .54 4.27 4.27 0 01-1.44-1.62 4.18 4.18 0 01-.52-2.06 4.27 4.27 0 01.59-2.18 12.24 12.24 0 003.94 3.19 12.07 12.07 0 005 1.34 4.94 4.94 0 01-.11-1A4.17 4.17 0 0113 4.69a4.35 4.35 0 016.22.1 8.22 8.22 0 002.74-1 4.16 4.16 0 01-1.9 2.38 8.55 8.55 0 002.49-.71z" />
    </svg>
  )
}

export default SvgTwitter
